export default "__VITE_ASSET__mmpTplpu__"